import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Environment, EnvironmentService } from '@galaxy/core';
import { SessionService } from '@galaxy/core';

@Injectable({
  providedIn: 'root',
})
export class ListingScoreApiService {
  private httpHost: string;

  constructor(
    private http: HttpClient,
    private snackbar: MatSnackBar,
    private environmentService: EnvironmentService,
    private sessionService: SessionService,
  ) {}

  setupHttpHostName(): string {
    if (this.httpHost) {
      return this.httpHost;
    }

    if (this.environmentService.getEnvironment() === Environment.PROD) {
      this.httpHost = 'https://listing-score-api-prod.vendasta-internal.com/listingscore.v1.ListingScore';
      return this.httpHost;
    }

    this.httpHost = 'https://listing-score-api-demo.vendasta-internal.com/listingscore.v1.ListingScore';
    return this.httpHost;
  }

  getListingScore(accountGroupId: string, sourceIds: string[]): Observable<any> {
    const body = {
      account_group_id: accountGroupId,
      source_ids: sourceIds,
    };
    const url = `${this.setupHttpHostName()}/GetScore`;
    return this.sessionService.getSessionId().pipe(
      switchMap((sessionId) => {
        return this.http.post(url, body, {
          headers: {
            'content-type': 'application/json; charset=UTF-8',
            Authorization: `Bearer ${sessionId}`,
          },
        });
      }),
    );
  }
}
